import { combineReducers } from 'redux';
import { cloneDeep } from 'lodash';

import {
	FETCH_DATA_SUCCESS,
	TOGGLE_FUNDS,
	TOGGLE_FUND,
	CLEAR_FILTERS,
	SET_FILTERED_FUNDS,
	LOGOUT_USER,
	CLOSE_DROPDOWNS,
} from '../types';

const toggleFund = (state, payload) => {
	const { id, selected } = payload;

	return {
		...state,
		[id]: { ...state[id], selected  }
	}
}

const deselectAllFunds = state => {
	const newFunds = cloneDeep(state);

	Object.entries(newFunds).forEach(([key, value]) => {
		value.selected = false;
	});
	return newFunds;
}

const byId = (state = {}, action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				...action.payload.files.entities.funds,
			}

		case TOGGLE_FUND:
			return toggleFund(state, action.payload);

		case CLEAR_FILTERS:
			return deselectAllFunds(state);

		case LOGOUT_USER:
			return {}

		default:
			return state;
	}
}

const allIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.funds);
			return keys.map(Number);

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const filteredIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.funds);
			return keys.map(Number);

		case SET_FILTERED_FUNDS:
			return action.payload

		case CLEAR_FILTERS:
			return action.payload.funds

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const metaInitialState = {
	active: false,
}

const meta = (state = metaInitialState, action) => {
	switch (action.type) {
		case TOGGLE_FUNDS:
			return {
				...state,
				active: !state.active,
			}
		
		case CLEAR_FILTERS:
			return {
				...state,
				active: false,
			}

		case LOGOUT_USER:
			return metaInitialState

		case CLOSE_DROPDOWNS:
			return metaInitialState
			
		default:
			return state;
	}
}

const funds = combineReducers({
	byId,
	allIds,
	filteredIds,
	meta,
});
export default funds;

export const getIsActive = state => state.meta.active;
export const getIds = state => state.allIds;
export const getFilteredIds = state => state.filteredIds;
export const getFunds = state => {
	const ids = getFilteredIds(state);
	const funds = ids.map(id => state.byId[id]);

	return funds.sort((a, b) => {
		var textA = a.title.toUpperCase();
		var textB = b.title.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	});
}
export const getSelectedFunds = state => {
	const ids = getIds(state);
	return ids.filter(id => state.byId[id].selected);
}


// WEBPACK FOOTER //
// ./src/store/funds/reducer.js